export default __webpack_public_path__ + "static/media/success.12b65940.m4a";